import api from "actions/api";
import store from "redux/Store";

export default class GoamaSubscriptionPaymentService {
  public subscription: ISubscriptionPayment | undefined;
  public extraData: any;

  public async initiatePayment({ subscription, extraData = {} }: { subscription: any; extraData?: any }) {
    this.subscription = subscription;
    this.extraData = extraData;

    try {
      // const urlParams = new URLSearchParams(window.location.search);
      // const app = urlParams.get("app");
      // const userid = urlParams.get("userid");
      // const country = urlParams.get("country");

      const { application, country } = store.getState().common;
      // console.log({ application, country, user });
      // return;

      const redirect_url =
        subscription?.config_slug === "kheli"
          ? `${window.location.protocol}//${window.location.host}/tournament?app=${application?.slug}&country=${country}&subRedirect=True`
          : undefined;

      // Step 1: Initiate payment
      const initiateResponse = await api.post(`subscriptions/payment/init/`, {
        config_slug: subscription?.config_slug,
        package_id: subscription?.package_id,
        ...(redirect_url && { redirect_url }), // ✅ Conditionally adding redirect_url
      });

      const checkoutURL = initiateResponse?.data?.checkoutURL;
      const paymentReference = initiateResponse?.data?.reference;

      if (subscription?.config_slug === "kheli" && checkoutURL) {
        // Step 2: Redirect to checkout URL (only for "kheli")
        // Store the payment reference for later verification after the user returns
        localStorage.setItem("paymentReference", paymentReference);
        window.location.href = checkoutURL;
        return; // Stop execution as user will return after payment
      } else if (paymentReference) {
        // Step 3: Verify payment immediately (for other apps)
        return this.verifyPayment(paymentReference);
      }
    } catch (e) {
      console.error("Payment initiation failed:", e);
      throw e;
    }
  }

  public async verifyPayment(paymentReference: string) {
    try {
      if (!paymentReference) throw new Error("Missing payment reference for verification.");
      const verifyResponse = await api.get(`subscriptions/${paymentReference}/payment/verify/`);

      return verifyResponse.data;
    } catch (e) {
      console.error("Payment verification failed:", e);
      throw e;
    }
  }

  public async checkForSubRedirectWithRetry(maxRetries = 5, delay = 3000): Promise<any> {
    const urlParams = new URLSearchParams(window.location.search);
    const subRedirect = urlParams.get("subRedirect");
    console.log("calling");

    if (subRedirect === "True") {
      const paymentReference = localStorage.getItem("paymentReference");

      if (!paymentReference) {
        throw new Error("Payment reference not found.");
      }

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          const result = await this.verifyPayment(paymentReference);
          if (result?.status !== "pending") {
            return result;
          }

          console.log(`Attempt ${attempt}: Status is still pending... retrying in ${delay}ms`);
          await new Promise(resolve => setTimeout(resolve, delay));
        } catch (error) {
          console.error(`Attempt ${attempt} failed`, error);
          if (attempt === maxRetries) throw error;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }

      throw new Error("Payment verification timed out after retries.");
    }

    return null;
  }

  public async UnsubscribeService() {
    try {
      const res = await api.get(`subscriptions/user/unsubscribe/`);
      return res?.data || null;
    } catch (e) {
      console.error("Unsubscribe failed:", e);
      throw e;
    }
  }

  protected generateRedirectURL(path: string, queryParams: Record<string, any>): string {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const baseURL = `${protocol}//${host}/${path}`;

    const params = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join("&");

    return `${baseURL}?${params}`;
  }
}
